import { render, staticRenderFns } from "./PPTLoding.vue?vue&type=template&id=d4bd9f1c&scoped=true&"
var script = {}
import style0 from "./PPTLoding.vue?vue&type=style&index=0&id=d4bd9f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd9f1c",
  null
  
)

export default component.exports